<template>
  <div>
    <nx-chip v-if="type" dark default class="hidden-sm-and-down">
      {{ $tc(`message.content.type.${type}`) }}
    </nx-chip>

    <nx-chip dark default class="hidden-sm-and-down">
      ID: {{ id }}
    </nx-chip>

    <slot/>

    <nx-chip v-if="isDraft" dark alert class="hidden-sm-and-down">
      {{ $t('message.content.status.draft') }}
    </nx-chip>

    <v-tooltip v-if="isScheduled" bottom>
      <template #activator="{on}">
        <nx-chip class="hidden-sm-and-down" dark alert>
          {{ $t('message.metadata.schedulePublish') }} {{ schedulePublishDate | formatDate }}
        </nx-chip>
      </template>
    </v-tooltip>

    <nx-chip v-if="isPublished" dark success class="hidden-sm-and-down">
      {{ $t('message.metadata.published') }}
    </nx-chip>

    <nx-chip v-if="unpublishedDate && !isPublished" dark alert class="hidden-sm-and-down">
      {{ $t('message.metadata.unpublishedDate') }} {{ unpublishedDate | formatDate }}
    </nx-chip>

    <v-tooltip v-if="scheduleUnpublishDate" bottom>
      <template #activator="{on}">
        <nx-chip class="hidden-sm-and-down" dark alert>
          {{ $t('message.metadata.scheduleUnpublish') }} {{ scheduleUnpublishDate | formatDate }}
        </nx-chip>
      </template>
    </v-tooltip>

    <nx-chip v-if="!isPublished && hasRedirection" class="hidden-sm-and-down" dark default>
      {{ $t('message.metadata.hasRedirection') }}
    </nx-chip>

    <v-tooltip v-if="isPublished" bottom class="hidden-sm-and-down">
      <nx-chip slot="activator" class="hidden-sm-and-down" dark default>
        {{ publicationDate | formatDate }}
      </nx-chip>
      {{ $t('message.metadata.contentHeaderPublishedDate') }}
    </v-tooltip>

    <v-tooltip v-else bottom class="hidden-sm-and-down">
      <nx-chip slot="activator" class="hidden-sm-and-down" dark default>
        {{ creationDate | formatDate }}
      </nx-chip>
      {{ $t('message.metadata.creationDate') }}
    </v-tooltip>
  </div>
</template>

<script>
import NxChip from '@/components/chips/Chip';

export default {
  name: 'nx-content-editor-header-common-chips',
  components: { NxChip },
  props: {
    type: String,
    creationDate: String,
    publicationDate: String,
    isDraft: Boolean,
    isScheduled: Boolean,
    isPublished: Boolean,
    id: Number,
    hasRedirection: Boolean,
    schedulePublishDate: String,
    scheduleUnpublishDate: String,
    unpublishedDate: String,
  },
};
</script>
